angular.module('public.security-manager.employee').component('gccsEmployeeClientApproveClients', {
  template: require('./template.pug'),
  controller: 'EmployeeClientApproveClientsController',
  bindings: {
    employee: '<',
    clients: '<',
    selectedClientId: '='
  }
});
